// components/StreamingDots.tsx — ported from docs/superpowers/design-2026-04-21/messages.jsx

import type { JSX } from 'react';
import { useTokens } from '../state/theme';

export function StreamingDots(): JSX.Element {
  const tokens = useTokens();
  return (
    <div style={{ display: 'inline-flex', gap: 3, alignItems: 'center' }}>
      {[0, 1, 2].map((i) => (
        <span key={i} style={{
          display: 'inline-block', width: 5, height: 5, borderRadius: '50%',
          background: tokens.textMuted,
          animation: `prof-blink 1.2s infinite ${i * 0.18}s ease-in-out`,
        }}/>
      ))}
    </div>
  );
}
